import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AutoCenter, DotLoading, Button } from "antd-mobile";
import qs from "qs";
import api from "../../api";
import "./style.less";

const Wechat = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = qs.parse(location.search.slice(1));

  const [authBotton, setAuthBotton] = useState(false);

  const handleWechatAuth = () => {
    // 请求oauth2授权链接
    api.wechatOauth2url().then((res) => {
      if (res.data.code === 0) {
        window.location.href = res.data.data;
      }
    })
  }

  useEffect(() => {
    // 有code字段说明是从微信跳转回来的
    if (params?.code) {
      api.wechatOauth2CodeToAccessToken(params).then((res) => {
        if (res.data.code === 0) {
          if (res.data.data.userId === 0) {
            navigate("/login/wechat/bind/mobile")
          } else {
            navigate("/home")
          }
        }
      })
    } else {
      setAuthBotton(true)
    }
  }, [])

  return (
    <div className="wechat-login-wrapper">
      {
        authBotton ?
          <AutoCenter>
            <div className="wechat-login-hint">
              <span>请登陆后使用充电服务，谢谢!</span>
            </div>
            <Button block color="success" onClick={() => handleWechatAuth()}>登 陆</Button>
          </AutoCenter>
          :
          <AutoCenter>
            <div>
              <span>登陆中</span>
              <DotLoading color='currentColor' />
            </div>
          </AutoCenter>
      }
    </div>
  )
}

export default Wechat;